import React from 'react';

interface HighlightedTextProps {
    text: string;
    className?: string;
    highlightClassName?: string;
}

/**
 * Component that renders text with highlighted sections marked by **text** syntax
 * Works with i18n translated strings that contain markdown-style highlighting
 */
const HighlightedText: React.FC<HighlightedTextProps> = ({
    text,
    className = '',
    highlightClassName = 'font-bold text-emerald-600 dark:text-emerald-400'
}) => {
    // Parse the text and split by **highlighted** sections
    const parseText = (text: string) => {
        const parts = text.split(/(\*\*.*?\*\*)/g);

        return parts.map((part, index) => {
            if (part.startsWith('**') && part.endsWith('**')) {
                // Remove the ** markers and render as highlighted
                const highlightedText = part.slice(2, -2);
                return (
                    <span key={index} className={highlightClassName}>
                        {highlightedText}
                    </span>
                );
            }
            // Regular text
            return part;
        });
    };

    return (
        <span className={className}>
            {parseText(text)}
        </span>
    );
};

export default HighlightedText;
